import React from 'react';
import { Box, Container, styled, Typography } from '@mui/material';
import useAuth from '../../../../hooks/authentication/useAuth';
import { useTranslation } from 'react-i18next';
import { B2B_URL } from '../../../../utils/constans/constans';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '6px 3.175%',
    borderBottom: '1px solid #ededed',
}));
const BoxItem = styled(Box)(({ theme }) => ({
    cursor: 'pointer',
    padding: '0 10px',
    alignItems: 'center',
    ':not(:last-child)': {
        borderRight: '1px solid #ededed',
    },
    '.MuiTypography-root': {
        color: `${theme.palette.primary[400]}`,
    },
}));

export const TopHeaderNav: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <StyledBox>
                <BoxItem>
                    <Typography>
                        <a href={B2B_URL}>
                            {t('NAVIGATION.NAVIGATION_TOP.WEBSHOP')}
                        </a>
                    </Typography>
                </BoxItem>
            </StyledBox>
        </>
    );
};
